import { render, staticRenderFns } from "./textfield-screen.vue?vue&type=template&id=457b776a&scoped=true"
import script from "./textfield-screen.vue?vue&type=script&lang=js"
export * from "./textfield-screen.vue?vue&type=script&lang=js"
import style0 from "./textfield-screen.vue?vue&type=style&index=0&id=457b776a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b776a",
  null
  
)

export default component.exports